"use strict";
/**
 * @author tatevik.marikyan
 * @since 13/03/2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var model_1 = require("../impl/model");
var meta_model_1 = require("../impl/model/meta.model");
/**
 * Deserializes the Meta object.
 * @param {any} responseMeta - JSON object containing the data of meta.
 * @returns {Meta} the object, which contains data of meta
 * @private
 */
function deserializeMeta(responseMeta) {
    var meta = new meta_model_1.Meta();
    meta.setTotalRowCount(responseMeta.totalRowCount);
    meta.setValidations(createValidations(responseMeta.validationErrors));
    // TODO: Remove this along with createValidationErrors and _createValidationError on next major release
    meta.setValidationErrors(createValidationErrors(responseMeta.validationErrors));
    meta.setPermissionWarnings(responseMeta.permissionWarnings);
    meta.setStatus(responseMeta.status);
    return meta;
}
exports.deserializeMeta = deserializeMeta;
/**
 * Creates array of validation errors from response.
 * @param {Array<any>} responseValidationErrors - JSON object containing the array of validation errors.
 * @returns {Array<Validation>} array of Validation object
 * @private
 */
function createValidations(responseValidationErrors) {
    var validationErrors = [];
    responseValidationErrors &&
        responseValidationErrors.forEach(function (responseValidationError) {
            validationErrors.push(_createValidation(responseValidationError));
        });
    return validationErrors;
}
exports.createValidations = createValidations;
/**
 * Creates array of validation errors from response.
 * @param {Array<any>} responseValidationErrors - JSON object containing the array of validation errors.
 * @returns {Array<ValidationError>} array of Validation object
 * @private
 */
function createValidationErrors(responseValidationErrors) {
    var validationErrors = [];
    responseValidationErrors &&
        responseValidationErrors.forEach(function (responseValidationError) {
            validationErrors.push(_createValidationError(responseValidationError));
        });
    return validationErrors;
}
exports.createValidationErrors = createValidationErrors;
/**
 * Creates an object, containing validation's information.
 * @param {any} responseValidationError - JSON object containing the data of validation error.
 * @returns {Array<Validation>} array of Validation objects
 * @private
 */
function _createValidation(responseValidationError) {
    return new idm_validation_calculation_service_client_js_1.Validation(messageToMultilingualString(responseValidationError.message), messageToMultilingualString(responseValidationError.messageDescription), idm_validation_calculation_service_client_js_1.ValidationSeverity[responseValidationError.validationSeverity], idm_validation_calculation_service_client_js_1.ValidationPriority[responseValidationError.validationPriority], responseValidationError.validatorLabel, responseValidationError.relatedMetaFieldIds.map(wrapperToMetaFieldId), responseValidationError.validationDisplay
        ? new idm_validation_calculation_service_client_js_1.ValidationDisplay(idm_validation_calculation_service_client_js_1.ValidationDisplayType[responseValidationError.validationDisplay.displayType], new Map([
            [
                'fields',
                responseValidationError.validationDisplay.displayData,
            ],
        ]))
        : undefined, responseValidationError.messageData
        ? new idm_validation_calculation_service_client_js_1.ValidationMessageData(messageToMultilingualString(responseValidationError.messageData.message), responseValidationError.messageData.data)
        : undefined, responseValidationError.messageDescriptionData
        ? new idm_validation_calculation_service_client_js_1.ValidationMessageData(messageToMultilingualString(responseValidationError.messageDescriptionData.message), responseValidationError.messageDescriptionData.data)
        : undefined, responseValidationError.identityId);
}
/**
 * Creates object containing validation error information.
 * @param {any} responseValidationError - JSON object containing the data of validation error.
 * @returns {Array<ValidationError>} array of ValidationError object
 * @private
 */
function _createValidationError(responseValidationError) {
    var validationError = new model_1.ValidationError();
    var keys = Object.keys(responseValidationError.message.values);
    var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    keys.forEach(function (key) {
        multilingualStringBuilder.withValueForLanguage(parseInt(key, 10), responseValidationError.message.values[key]);
    });
    validationError.setMessage(multilingualStringBuilder.build());
    validationError.identityId = responseValidationError.identityId;
    validationError.setRelatedFields(responseValidationError.relatedFields);
    validationError.validationDisplay = model_1.ValidationDisplay.fromResponse(responseValidationError.validationDisplay);
    validationError.validatorLabel = responseValidationError.validatorLabel;
    return validationError;
}
function messageToMultilingualString(message) {
    var keys = Object.keys(message.values);
    var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    keys.forEach(function (key) {
        multilingualStringBuilder.withValueForLanguage(parseInt(key, 10), message.values[key]);
    });
    return multilingualStringBuilder.build();
}
function wrapperToMetaFieldId(metaFieldIdWrapper) {
    return new idm_kb_service_client_js_1.MetaFieldId(new idm_kb_service_client_js_1.MetaCategoryId(metaFieldIdWrapper.metaCategoryId.systemName), metaFieldIdWrapper.systemName, metaFieldIdWrapper.groupId
        ? new idm_kb_service_client_js_1.MetaGroupId(metaFieldIdWrapper.groupId.systemName)
        : undefined);
}
function isCompoundField(field) {
    var fieldType = field.getType();
    return (fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.LOOKUP);
}
exports.isCompoundField = isCompoundField;
function isFieldValueNotEmpty(field, entity) {
    var fieldType = field.getType();
    var fieldName = field.getSystemName();
    if (fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.LOOKUP) {
        return entity.getProperty(fieldName).value !== null;
    }
    else if (fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT ||
        fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
        return entity.getProperty(fieldName).value.length > 0;
    }
}
exports.isFieldValueNotEmpty = isFieldValueNotEmpty;
//# sourceMappingURL=serialization-helper.js.map